// src/utils/getDisplayBadge.js
export const getDisplayBadge = (userBadges) => {
    if (!userBadges || userBadges.length === 0) return null;

    // 7.4 : Ordre de priorité (Vérification > Rôle > Accomplissement)
    const priorityOrder = {
        'verification': 1,
        'role': 2,
        'accomplishment': 3,
        'temporary': 4
    };

    // On trie les badges par priorité et on prend le premier
    const sorted = [...userBadges].sort((a, b) => {
        const catA = a.badge?.category || 'accomplishment';
        const catB = b.badge?.category || 'accomplishment';
        return (priorityOrder[catA] || 99) - (priorityOrder[catB] || 99);
    });

    return sorted[0];
};